import { createI18n } from 'vue-i18n'
import en from './locales/en'
import es from './locales/es'

const i18n = createI18n({
  legacy: false, // use Composition API
  globalInjection: true, // expose $t / $tm / $rt in templates
  locale: 'en', // primary audience is U.S. employers → default to English
  fallbackLocale: 'es',
  silentTranslationWarn: true,
  missingWarn: false,
  fallbackWarn: false,
  messages: {
    en,
    es
  },
  warnHtmlMessage: false
})

export default i18n
